import styled from 'styled-components';

export const BadgeContainer = styled.div<{ color: string; isOverflow?: boolean, width?: string, height?: string, $mobileSize?: string, $offsetTop?: string, $offsetRight?: string, $fontWeight?: number, $lineHeight?: string }>`
  display: flex;
  width: ${({ $width}) =>  $width ? $width : '24px'};
  height: ${({ $height}) =>  $height ? $height : '24px'};
  justify-content: center;
  align-items: center;
  position: absolute;
  right: ${({ $offsetRight }) => $offsetRight || '-8px'};
  top: ${({ $offsetTop }) => $offsetTop || '-8px'};
  color: white;
  border-radius: 50%;
  background: ${({ $color}) =>  $color};
  font-size: ${({ $fz}) =>  `${$fz}px`};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  // z-index: 100;
  font-weight: ${({ $fontWeight }) => $fontWeight || 600};
  line-height: ${({ $lineHeight }) => $lineHeight || 1};
  box-sizing: border-box;

  @media (max-width: 768px) {
      width: ${({ $mobileSize }) => $mobileSize || '18px'};
      height: ${({ $mobileSize }) => $mobileSize || '18px'};
  }
`;

export const IconContainer = styled.span`
  display: flex;
  align-items: center;
`;